import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExtensionsPage } from "./extensions";
import { FlxCommonsModule } from "@questrade/flx-commons";
import { FlxDoclistComponentModule } from '../../components/flx-doclist/flx-doclist.module';
import { ExtMagento_1PageModule } from './ext-platforms/ext-magento-1/ext-magento-1.module';
import { ExtMagento_2PageModule } from './ext-platforms/ext-magento-2/ext-magento-2.module';
import { DevBreadcrumbsComponentModule } from '../../components/dev-breadcrumbs/dev-breadcrumbs.module';
import { DevJumbotronComponentModule } from '../../components/dev-jumbotron/dev-jumbotron.module';

@NgModule({
    declarations: [
        ExtensionsPage,
    ],
    imports: [
        FlxCommonsModule,
        FlxDoclistComponentModule,
        ExtMagento_1PageModule,
        ExtMagento_2PageModule,
        IonicPageModule.forChild(ExtensionsPage),
        DevBreadcrumbsComponentModule,
        DevJumbotronComponentModule
    ],
    exports: [
        ExtensionsPage
    ]
})
export class ExtensionsPageModule { }



// WEBPACK FOOTER //
// ./src/pages/extensions/extensions.module.ts